/* THE ALLIANCE LEAGUE — official sponsors of the AL Riotball Arena, Year 2355.
   Five partners keep the arena lit, fed, and on the air; this is who they are. */
import { Link } from "react-router-dom";
import { Dna, Drumstick, Hexagon, RadioTower, Zap, ArrowRight } from "lucide-react";
import { Footer } from "../components/Footer";
import { AllianceSponsorsBanner } from "../components/AllianceSponsorsBanner";

const SPONSORS = [
  {
    slug: "bio-hack",
    icon: Dna,
    name: "BIO HACK",
    field: "GENETIC ENHANCEMENT",
    role: "OFFICIAL HUMAN PERFORMANCE PARTNER",
    about:
      "Bio Hack Laboratories engineered the enhancement tubes every runner cracks before first light. Their gene-spliced serums tune reflex, stamina, and recovery for arena-grade punishment — legally grey in nine sectors, gloriously legal in the three that host playoff games.",
    footprint: "The free daily ration tube, and the Bio Hack boosts behind every power throw and sprint burst in the arena.",
    link: null,
  },
  {
    slug: "rad-burger",
    icon: Drumstick,
    name: "RAD BURGER",
    field: "ATOMIC TASTE",
    role: "OFFICIAL NUTRITION PARTNER",
    about:
      "Born in the glowing ruins of Sector 7's reactor row, Rad Burger atomically grills every patty in 1.8 seconds flat. Their winged burgermark is the last hot meal most runners see before a match — and the first one they want after the final siren.",
    footprint: "Feeds the matchday roster and keeps the concession grid humming from gates open to full time.",
    link: null,
  },
  {
    slug: "power-grid",
    icon: Zap,
    name: "THE POWER GRID",
    field: "ENERGIZING THE SECTORS",
    role: "OFFICIAL ENERGY PARTNER",
    about:
      "The Power Grid Corporation runs the current beneath all twelve sectors — every floodlight, every electronic goal, every scoreboard glows because their reactors never sleep. When the arena lights cut for a Night Ravens power play, that is also them. Allegedly.",
    footprint: "Powers the moving electronic goal, the broadcast rig, and every floodlight in the AL Riotball Arena.",
    link: null,
  },
  {
    slug: "sectors",
    icon: Hexagon,
    name: "SECTORS 1-12",
    field: "UNIFIED URBAN REGIONS",
    role: "OFFICIAL TERRITORY PARTNER",
    about:
      "The Unified Urban Regions govern the twelve sectors the league calls home — venue permits, safe-passage corridors, and the ground the arena stands on. Their honeycomb charter turned twelve feuding city-states into one tour map.",
    footprint: "Sanctions every venue on tour and keeps the corridors between sectors open for runners and fans.",
    link: null,
  },
  {
    slug: "wasteland-radio",
    icon: RadioTower,
    name: "WASTELAND RADIO",
    field: "GHOST TRANSMISSIONS",
    role: "OFFICIAL BROADCAST PARTNER",
    about:
      "Broadcasting from an unlisted frequency since the fall, Wasteland Radio carries every match, marathon, and ghost transmission across the dunes. If you heard the final siren from three sectors away, their tower did that.",
    footprint: "Carries every AL Riotball match live — and the 24-hour Dolo marathon broadcast.",
    link: { to: "/wasteland-radio", label: "TUNE IN" },
  },
];

export default function Sponsors() {
  return (
    <main className="sponsors-page" data-testid="sponsors-page">
      <section className="sponsors-hero">
        <span className="sponsors-eyebrow">THE ALLIANCE LEAGUE // YEAR 2355</span>
        <h1>OFFICIAL SPONSORS.</h1>
        <p>
          Five powers keep the AL Riotball Arena lit, fed, governed, and on the air. Professional partners of the league —
          this is who they are, and what they run.
        </p>
        <AllianceSponsorsBanner large />
      </section>
      <section className="sponsors-grid" data-testid="sponsors-grid">
        {SPONSORS.map((s, i) => (
          <article key={s.slug} className="sponsor-card" data-testid={`sponsor-card-${s.slug}`}>
            <div className="sponsor-card-head">
              <span className="sponsor-icon" aria-hidden="true">
                <s.icon size={30} />
              </span>
              <div>
                <span className="sponsor-num">PARTNER 0{i + 1}</span>
                <h2>{s.name}</h2>
                <span className="sponsor-field">{s.field}</span>
              </div>
            </div>
            <span className="sponsor-role">{s.role}</span>
            <p className="sponsor-about">{s.about}</p>
            <div className="sponsor-footprint">
              <span>ARENA FOOTPRINT</span>
              <p>{s.footprint}</p>
            </div>
            {s.link ? (
              <Link to={s.link.to} className="sponsor-link" data-testid={`sponsor-link-${s.slug}`}>
                {s.link.label} <ArrowRight size={13} />
              </Link>
            ) : null}
          </article>
        ))}
      </section>
      <section className="sponsors-cta">
        <p>THE ARENA THEY BUILT IS LIVE RIGHT NOW.</p>
        <Link to="/riotball" className="sponsors-cta-button" data-testid="sponsors-cta-riotball">
          ENTER THE AL RIOTBALL ARENA <ArrowRight size={15} />
        </Link>
      </section>
      <Footer />
    </main>
  );
}
